import React from "react";

function Loader() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="100%"
      fill="none"
      viewBox="0 0 135 117"
    >
      <g fill="#52174f" filter="url(#filter0_d_4_16)">
        <path d="M68.092 94.618V49.201c-3.314-1.514-7.107-2.775-11.38-3.784a92.917 92.917 0 00-12.818-2.397 202.573 202.573 0 00-2.878 11.48 181.233 181.233 0 00-2.223 11.606c-.61 3.785-1.09 7.528-1.44 11.229a107.92 107.92 0 00-.522 10.344c0 3.701.261 7.317.784 10.85.61 3.532 1.875 7.023 3.794 10.471-2.006 0-4.099-.21-6.279-.631-2.18-.42-4.185-1.388-6.017-2.901-1.83-1.43-3.357-3.533-4.578-6.308-1.133-2.692-1.7-6.35-1.7-10.976 0-2.944.218-6.224.654-9.84.436-3.617 1.09-7.401 1.962-11.354.872-3.953 1.918-7.99 3.14-12.111a189.07 189.07 0 014.316-12.364 63.435 63.435 0 00-7.194.63c-2.18.337-4.099.842-5.756 1.515-1.57.589-2.834 1.303-3.793 2.144-.959.841-1.439 1.767-1.439 2.776 0 .336.044.589.131.757 2.268.673 3.401 2.06 3.401 4.163 0 1.514-.567 2.565-1.7 3.154a7.829 7.829 0 01-3.663.883c-2.18 0-4.185-.589-6.016-1.766C4.959 55.509 4 53.365 4 50.337c0-2.019.654-3.827 1.962-5.425 1.22-1.598 2.921-2.944 5.101-4.037 2.267-1.178 4.883-2.06 7.848-2.65 3.052-.588 6.366-.882 9.94-.882.96 0 1.963.042 3.01.126 1.046 0 2.092.042 3.138.126 2.18-5.046 4.622-9.84 7.325-14.382 2.703-4.626 5.625-8.62 8.764-11.985 3.139-3.448 6.453-6.182 9.94-8.2C64.516 1.009 68.178 0 72.016 0c1.308 0 2.92.126 4.84.378 2.005.253 3.88.715 5.624 1.388v92.852H68.091zm-22.89-55.761c4.36.756 8.545 1.724 12.556 2.901 4.012 1.093 7.456 2.313 10.334 3.659V6.056c-2.18.168-4.317 1.135-6.41 2.901-2.092 1.682-4.142 3.995-6.147 6.939-1.918 2.944-3.75 6.392-5.494 10.345-1.744 3.869-3.357 8.074-4.84 12.615z"></path>
        <path d="M131 73.171c-2.267 7.654-6.453 13.5-12.557 17.536-6.104 3.953-13.298 5.93-21.582 5.93-11.248 0-20.012-3.827-26.29-11.48-6.191-7.654-9.287-19.219-9.287-34.694 0-5.803.523-11.69 1.57-17.662 1.046-5.972 2.877-11.354 5.493-16.148 2.616-4.878 6.104-8.873 10.464-11.985C83.258 1.556 88.84 0 95.553 0c3.314 0 6.453.42 9.418 1.262 2.965.84 5.537 2.102 7.717 3.784a17.338 17.338 0 015.363 6.056c1.308 2.439 1.962 5.299 1.962 8.579 0 2.69-.523 4.836-1.57 6.434-1.046 1.598-2.834 2.397-5.362 2.397-1.221 0-2.398-.169-3.532-.505-1.046-.42-1.918-1.01-2.616-1.766.785-.589 1.482-1.808 2.093-3.659.697-1.85 1.046-3.953 1.046-6.308 0-4.037-1.003-6.98-3.008-8.83-2.006-1.935-4.665-2.902-7.979-2.902-3.924 0-7.325 1.261-10.202 3.784-2.79 2.44-5.102 5.72-6.933 9.84-1.83 4.122-3.183 8.79-4.055 14.004-.784 5.215-1.177 10.597-1.177 16.148 0 6.897.61 12.784 1.831 17.662 1.221 4.878 3.009 8.873 5.363 11.985 2.355 3.112 5.232 5.425 8.633 6.939 3.488 1.43 7.456 2.145 11.903 2.145 5.668 0 10.376-1.178 14.126-3.533 3.75-2.439 6.802-6.308 9.156-11.606L131 73.17z"></path>
      </g>
      <defs>
        <filter
          id="filter0_d_4_16"
          width="135"
          height="100%"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="4"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4_16"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_4_16"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default Loader;
